import { Image, Row } from 'antd';
import HeroButton from '../../../components/buttons/HeroButton';
import ScreenFrame from './ScreenFrame';
import { Suspense } from 'react';
import { SpinLoader } from '../../../components/common/SpinLoader';
import classNames from 'classnames';

type HeroSectionProps = {
  t: (key: string) => string;
  scrollToRegionalPriceRef: () => void;
  scrollToLatestReportsRef: () => void;
};

const HeroSection = ({
  t,
  scrollToLatestReportsRef,
  scrollToRegionalPriceRef,
}: HeroSectionProps) => {
  // const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  return (
    <div className="hero-section section">
      <Suspense fallback={<SpinLoader />}>
        {/* <div
          className={classNames(
            'rounded-[48px] transition-opacity duration-500 bg-gradient-to-b from-[#004cd3] via-[#417fdf] to-[#81b2ec]',
            { '!h-0 opacity-0': imageLoaded },
            { 'opacity-100 lg:h-[1124px]': !imageLoaded }
          )}
        /> */}
        <Image
          width="100%"
          preview={false}
          src={'/images/HomepageHeroImage.svg'}
          className="hero-image"
          // onLoad={() => setImageLoaded(true)}
        />
      </Suspense>
      <div className="hero-content">
        <h1 className="title"> {t('title')} </h1>
        <h2 className="subtitle"> {t('subtitle')} </h2>
        <Row className="flex justify-center gap-8">
          <HeroButton
            children={t('action_btn1')}
            handleOnClick={() => {
              scrollToRegionalPriceRef();
            }}
          />
          {/* --- Not implemented yet --- */}
          {/* <HeroButton
            children={t('action_btn2')}
            handleOnClick={() => {
              scrollToLatestReportsRef();
            }}
          /> */}
        </Row>
      </div>
      <div className="frames">
        <ScreenFrame image={'/images/screenshots/screenshot_1.png'} position="left" />
        <ScreenFrame image={'/images/screenshots/screenshot_2.png'} position="mid" />
        <ScreenFrame image={'/images/screenshots/screenshot_3.png'} position="right" />
      </div>
    </div>
  );
};

export default HeroSection;
